import { render, staticRenderFns } from "./FaceDirectionModal.vue?vue&type=template&id=54c4c0fd&scoped=true&"
import script from "./FaceDirectionModal.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionModal.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionModal.vue?vue&type=style&index=0&id=54c4c0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4c0fd",
  null
  
)

export default component.exports